import React, { useEffect, useState } from 'react';
import styles from './AdminClubSingle.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { resetClubSingle, resetUpdateClub } from '../../../redux/slices/app.slice';
import { clubSingle } from '../../../redux/actions/app/clubSingle';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../components/admin/Loading/Loading';
import { updateClub } from '../../../redux/actions/app/updateClub';
import { Box } from '@mui/material';
import InputCustom from '../../../components/admin/InputCustom/InputCustom';
import { formatPhoneNumber, getPhoneMask, stripCountryCodeFromPhone } from '../../../utils/getPhoneMask';
import { useWatch } from 'react-hook-form';

const PhoneCountryField = ({ form, citizenships, citizenshipId, activeCitizenship, countryOptions, phoneFormat }) => {
  const selectedCitizenshipId = useWatch({ control: form.control, name: 'citizenshipId' }) || citizenshipId;
  const selectedCitizenship = citizenships?.find((country) => country?.id === selectedCitizenshipId) ?? activeCitizenship;
  const selectedPhoneFormat = getPhoneMask(selectedCitizenship) || phoneFormat;

  return (
    <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: '220px 1fr', alignItems: 'start' }}>
      <Box sx={{ minWidth: 0 }}>
        <InputCustom
          required={false}
          form={form}
          name={'citizenshipId'}
          label={'Страна / код'}
          isSelect
          options={countryOptions}
          onChange={(citizenshipId) => {
            form.setValue('phone', '', { shouldValidate: true, shouldDirty: true });
            return citizenshipId;
          }}
        />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <InputCustom required={false} form={form} name={'phone'} label={'Телефон логина'} isNumber format={selectedPhoneFormat} placeholder={selectedPhoneFormat} />
      </Box>
    </Box>
  );
};

const getDateFromTimeString = (time) => {
  if (!time) {
    return '';
  }
  // 1. Создаем dayjs объект с текущей датой
  let datetime = dayjs();

  // 2. Разбиваем строку времени на часы и минуты
  const [hours, minutes] = time.split(':').map(Number);

  // 3. Устанавливаем время
  datetime = datetime.hour(hours).minute(minutes).second(0).millisecond(0).toDate();

  return datetime;
};

const AdminClubSingle = () => {
  const data = [
    [
      {
        label: 'Лого',
        type: 'image',
        name: 'logo',
        width: '200px',
      },
      [
        {
          label: 'Название',
          type: 'text',
          name: 'name',
        },

        { required: false, label: 'Адрес', type: 'text', name: 'address' },
      ],
    ],
  ];
  const [fields, setFields] = useState([]);
  const [citizenshipsData, setCitizenshipsData] = useState([]);
  const onFormatData = ({
    club: { images, tables, clubTags, averageBill, menuLink, siteLink, yandexLink, closeTime, openTime, address, name, logo, cityId, citizenshipId, email, phone, creator },
    cities,
    tags,
    citizenships,
  }) => {
    setCitizenshipsData(citizenships ?? []);
    const loginCitizenshipId = creator?.citizenshipId ?? creator?.citizenship?.id ?? citizenshipId;
    const loginPhone = creator?.phone ?? phone;
    const activeCitizenship = citizenships?.find((country) => country?.id === loginCitizenshipId) ?? citizenships?.[0];
    const commonTags = tags.filter((item) => item.isCommon)?.map((item) => ({ value: item.id, label: item.name }));
    const otherTags = tags.filter((item) => !item.isCommon)?.map((item) => ({ value: item.id, label: item.name }));
    let tablesFields = [];
    let tablesValue = {};
    [...(tables ?? [])]
      ?.sort((a, b) => a.tableTypeId.localeCompare(b.tableTypeId))
      ?.map((table) => {
        tablesFields.push({
          disabled: true,
          label: `Стол - ${table?.type?.name}`,
          type: 'string',
          name: `tables.${table.id}`,
        });
        tablesValue = { ...tablesValue, [table.id]: table?.quantity };
      });

    const fields = [
      { label: 'Фото', type: 'gallery', name: 'images' },
      [
        {
          label: 'Город',
          type: 'select',
          name: 'cityId',
          options: cities?.map((club) => ({ value: club?.id, label: club?.name })),
        },
      ],

      [
        {
          required: false,
          label: 'Email',
          type: 'text',
          name: 'email',
          rules: {
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Неверный формат почты',
            },
          },
        },
      ],
      [
        {
          label: 'Часы работы, от',
          type: 'time',
          name: 'openTime',
        },
        {
          label: 'Часы работы, до',
          type: 'time',
          name: 'closeTime',
        },
      ],
      {
        required: false,
        label: 'Ссылка на меню или ЯндексКарты',
        type: 'text',
        name: 'menuLink',
      },
      { required: false, label: 'Ссылка на Яндекс Карты (для отображения рейтинга)', type: 'text', name: 'yandexLink' },
      { required: false, label: 'Сайт', type: 'text', name: 'siteLink' },
      { required: false, label: 'Средний чек', type: 'number', name: 'averageBill' },
      [
        {
          type: 'custom',
          render: ({ form }) => {
            const countryOptions = citizenships?.map((country) => ({
              value: country?.id,
              label: country?.code ? `${country?.name} +${country?.code}` : country?.name,
            }));
            const phoneFormat = getPhoneMask(activeCitizenship);

            return <PhoneCountryField form={form} citizenships={citizenships} citizenshipId={loginCitizenshipId} activeCitizenship={activeCitizenship} countryOptions={countryOptions} phoneFormat={phoneFormat} />;
          },
        },
      ],
      [
        {
          label: 'Основние',
          type: 'checkbox',
          name: 'tags',
          options: commonTags,
        },
        {
          label: 'Дополнительно',
          type: 'checkbox',
          name: 'tags',
          options: otherTags,
        },
      ],
      tablesFields,
    ];

    let checkedTags = {};
    clubTags?.map((tag) => {
      checkedTags = { ...checkedTags, [tag?.clubTagsId]: true };
    });
    setFields([...data, ...fields]);
    return {
      logo,
      cityId,
      citizenshipId: loginCitizenshipId,
      email,
      phone: formatPhoneNumber(loginPhone, activeCitizenship),
      name,
      address,
      openTime: getDateFromTimeString(openTime),
      closeTime: getDateFromTimeString(closeTime),
      menuLink,
      siteLink,
      yandexLink,
      averageBill,
      tags: checkedTags,
      tables: tablesValue,
      images,
    };
  };
  const deleteProps = { successText: 'Клуб удален', confirmTitle: `Вы уверены что хотите удалить клуб`, status: 'DELETED' };
  const blockProps = { successText: 'Клуб заблокирован', confirmTitle: `Вы уверены что хотите заблокировать клуб`, status: 'BLOCKED' };
  const unblockProps = { successText: 'Клуб разблокирован', confirmTitle: `Вы уверены что хотите разблокировать клуб`, status: 'ACTIVE' };

  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    updateClub: { data: updateClubData, loading: updateClubLoading },
  } = useSelector((state) => state.app);
  const navigate = useNavigate();
  useEffect(() => {
    if (updateClubData) {
      toast.success('Клуб обновлен');
      navigate('/admin/clubs');
      dispatch(resetUpdateClub());
    }
  }, [updateClubData]);

  return (
    <>
      <AdminSinglePage
        onSubmit={(data) => {
          const { images, logo, tags, tables, ...otherData } = data;
          const activeCitizenship = citizenshipsData?.find((country) => country?.id === data?.citizenshipId);
          const formatData = {
            ...otherData,
            clubId: id,
            closeTime: dayjs(data.closeTime).format('HH:mm').toString(),
            openTime: dayjs(data.openTime).format('HH:mm').toString(),
            phone: stripCountryCodeFromPhone(data?.phone, activeCitizenship),
          };

          dispatch(updateClub(formatData));
        }}
        reset={resetClubSingle}
        fetch={clubSingle}
        sliceName={'app'}
        actionName={'clubSingle'}
        onFormatData={onFormatData}
        fields={fields}
        isSave
        pathList="/admin/clubs"
        deleteProps={deleteProps}
        blockProps={blockProps}
        unblockProps={unblockProps}
        propName={'club'}
        type={'CLUB'}
      />
      {updateClubLoading && <Loading />}
    </>
  );
};

export default AdminClubSingle;
